__turbopack_context__.v({
  "empty": "WShopPromotionalProducts-module__Kfsq9G__empty",
  "header": "WShopPromotionalProducts-module__Kfsq9G__header",
  "heading": "WShopPromotionalProducts-module__Kfsq9G__heading",
  "productList": "WShopPromotionalProducts-module__Kfsq9G__productList",
  "root": "WShopPromotionalProducts-module__Kfsq9G__root",
  "showAllBtn": "WShopPromotionalProducts-module__Kfsq9G__showAllBtn",
});
